import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { changeInvalidPhonenumberApi } from "../../../../../services/authApi"
import Divider from '@mui/material/Divider';
import PhoneInput from 'react-phone-input-2'
import TextField from '@mui/material/TextField';
import { useState } from "react";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { toast } from "react-toastify";
import Link from "@mui/material/Link";


export default function ChangePhoneNumber({ authUserinfo }) {
  const [phoneNumberValue, setphoneNumberValue] = useState(null)
  const [step, setStep] = useState(1)
  const [disableButton, setDisableButton] = useState(false)
  const [confirmCode, setConfirmCode] = useState("")

  const handleChangePhonenumberSubmit = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      if (phoneNumberValue.toString().length < 5) {
        customToastify("error", "لطفا شماره تلفن همراه را وارد کنید", 3000)
        return false
      }
      setDisableButton(true);
      const response = await changeInvalidPhonenumberApi(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setStep(2);
        customToastify("success", resData["message"], 5000);
        // setTimeout(() => {
        //   handleCloseSignInBox(false);
        // }, 1000)
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  return (
    <Paper sx={{ mr: 2, p: 1, pt: 3 }}>
      {(authUserinfo["phoneNumber"]).toString().slice(0, 5) !== "98000" ? <>
        <Typography>امکان تغییر شماره همراه ثبت شده برای شما وجود ندارد</Typography>
        <Divider sx={{ my: 1 }}></Divider>
        <Typography>{`شماره تلفن همراه : ${authUserinfo["phoneNumber"]}`}</Typography>
      </> : <>
        <Typography> با ثبت شماره تلفن شما می توانید با شماره تلفن و کلمه عبور وارد سایت شوید</Typography>
        <Typography>همچنین درصورت فراموشی کلمه عبور، از طریق شماره تلفن می توانید کلمه عبور را بازیابی کنید</Typography>
        <Divider sx={{ my: 1 }}></Divider>
        {step == 1 ? <>
          <PhoneInput
            value={phoneNumberValue}
            isValid={(value, country) => {
              if (value.match(/12345/)) {
                return "شماره نامعتبر";
              } else if (value.match(/1234/)) {
                return false;
              } else {
                return true;
              }
            }}
            placeholder="شماره تلفن"
            countryCodeEditable={false}
            inputStyle={{ color: 'black', width: "220px" }}
            containerStyle={{ color: 'black', direction: "ltr" }}
            buttonStyle={{}}
            //   dropdownStyle={{height:'50px'}}
            country={'ir'}
            enableSearch={true}
            onChange={(phone, country) => {
              setphoneNumberValue(phone);
            }}
          />
          <Button
            type="submit"
            fullWidth
            disableButton
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
            onClick={() => {
              handleChangePhonenumberSubmit({ phoneNumber: phoneNumberValue })
            }}
          >
            دریافت کد
          </Button>
          <Link href="#"
            onClick={() => { setStep(2) }}
            variant="body2">
            کد را قبلا دریافت کرده ام !
          </Link>
        </> : <>
          <PhoneInput
            value={phoneNumberValue}
            isValid={(value, country) => {
              if (value.match(/12345/)) {
                return "شماره نامعتبر";
              } else if (value.match(/1234/)) {
                return false;
              } else {
                return true;
              }
            }}
            placeholder="شماره تلفن"
            countryCodeEditable={false}
            inputStyle={{ color: 'black', width: "220px" }}
            containerStyle={{ color: 'black', direction: "ltr" }}
            buttonStyle={{}}
            //   dropdownStyle={{height:'50px'}}
            country={'ir'}
            enableSearch={true}
            onChange={(phone, country) => {
              setphoneNumberValue(phone);
            }}
          />
          <Typography>
            کد تایید دریافتی را وارد کنید:
          </Typography>
          <TextField sx={{ m: 1 }} id="outlined-basic" label="کد تایید" variant="outlined" onChange={(e) => { setConfirmCode(e.target.value) }} />
          <Button
            type="submit"
            fullWidth
            disableButton
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
            onClick={() => {
              if (confirmCode.length < 1) {
                customToastify("error", "لطفا کد تایید را وارد کنید", 3000)
                return false
              }
              handleChangePhonenumberSubmit({ phoneNumber: phoneNumberValue, confirmCode })
            }}
          >
            ثبت شماره تلفن
          </Button>
          <Link href="#"
            onClick={() => { setStep(1) }}
            variant="body2">
            ارسال کد به یک شماره دیگر
          </Link>
        </>}
      </>}
    </Paper>
  );
}
